import { useNavigation } from '@react-navigation/native'

import { links } from 'utils/constants'

export const useNavigateBackOrHome = () => {
  const navigation = useNavigation<any>()

  const navigate = () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.reset({ index: 0, routes: [{ name: links.MAIN_TABS }] })
    }
  }

  return navigate
}
